export default "__VITE_ASSET__ddf12a03__"